import { defer, Observable, throwError } from "rxjs";
import { map, catchError } from "rxjs/operators";
import initializeAxios from "./axios-setup";
import { axiosRequestConfiguration } from "./config";

const axiosInstance = initializeAxios(axiosRequestConfiguration);

const handleError = (error: any) => {
  // Aquí puedes agregar lógica para logs, enviar a Sentry, etc.
  return throwError(() => error);
};

const get = <T>(url: string, queryParams?: object): Observable<T> => {
  return defer(() => axiosInstance.get<T>(url, { params: queryParams })).pipe(
    map(result => result.data),
    catchError(handleError)
  );
};

const post = <T>(url: string, body: any, queryParams?: object): Observable<T> => {
  return defer(() => axiosInstance.post<T>(url, body, { params: queryParams })).pipe(
    map(result => result.data),
    catchError(handleError)
  );
};

const postH = <T>(
  url: string,
  body: any,
  queryParams?: object
): Observable<{ data: T; headers: any }> => {
  return defer(() =>
    axiosInstance.post<T>(url, body, { params: queryParams })
  ).pipe(
    map(response => ({
      data: response.data,
      headers: response.headers
    })),
    catchError(handleError)
  );
};

const postHH = <T>(url: string, body: any, queryParams?: object): Observable<any> => {
  return defer(() => axiosInstance.post<T>(url, body, { params: queryParams })).pipe(
    catchError(handleError)
  );
};

const put = <T>(url: string, body: any, queryParams?: object): Observable<T> => {
  return defer(() => axiosInstance.put<T>(url, body, { params: queryParams })).pipe(
    map(result => result.data),
    catchError(handleError)
  );
};

const patch = <T>(url: string, body: any, queryParams?: object): Observable<T> => {
  return defer(() => axiosInstance.patch<T>(url, body, { params: queryParams })).pipe(
    map(result => result.data),
    catchError(handleError)
  );
};

const deleteR = <T>(url: string, id: number): Observable<T> => {
  return defer(() => axiosInstance.delete(`${url}/${id}`)).pipe(
    map(result => result.data),
    catchError(handleError)
  );
};

export default { get, post, postH, postHH, put, patch, delete: deleteR };
